import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, RadioButtonGroup, PanelRadioButton, ObjectSelect2, QuickTip} from 'shared/components';

const ApprovalChangeWarning = observer(({uiState}) => {
  const {willApprovePendingRequests, willModifySecondStageRequests, willApproveSecondStageRequests} = uiState;

  if (willApprovePendingRequests) {
    return (
      <QuickTip
        trait='caution'
        paragraphs={[
          t('time_off.policy.edit.APPROVAL_CHANGE_WARNING_PENDING_REQUESTS')
        ]}
      />
    );
  } else if (willModifySecondStageRequests) {
    return (
      <QuickTip
        trait='caution'
        paragraphs={[
          t('time_off.policy.edit.APPROVAL_CHANGE_WARNING_MODIFY_SECOND_STAGE_REQUESTS')
        ]}
      />
    );
  } else if (willApproveSecondStageRequests) {
    return (
      <QuickTip
        trait='caution'
        paragraphs={[
          t('time_off.policy.edit.APPROVAL_CHANGE_WARNING_APPROVE_SECOND_STAGE_REQUESTS')
        ]}
      />
    );
  } else {
    return null;
  }
});

const FirstStageApproverSelect = observer(({uiState}) => {
  const {typePolicy, firstStageAvailableAssignees, errors} = uiState;

  return <ObjectSelect2
    by='userId'
    label='time_off.policy.edit.approvals.Approver(s)'
    value={typePolicy.firstStageApprovers}
    items={firstStageAvailableAssignees}
    onAdd={approver => uiState.addFirstStageApprover(approver)}
    onRemove={approver => uiState.removeFirstStageApprover(approver)}
    errorMessage={errors.firstStageApprovers}
    multiple
    searchable
  />;
});

const ApprovalForm = observer(({uiState}) => {
  const {typePolicy, availableAssignees, errors, displayApprovalChangeWarning} = uiState;

  return (
    <Panel>
      <Panel.Header title={t('time_off.policy.edit.APPROVALS', {type: typePolicy.type.name})}/>
      {displayApprovalChangeWarning && <div className='mb2'><ApprovalChangeWarning uiState={uiState}/></div>}
      <RadioButtonGroup
        className={'table'}
        name='approvalType'
        selectedValue={typePolicy.approvalType}
        onChange={(name, value) => typePolicy.merge({approvalType: value, secondStageApprovalType: null, secondStageApprovalAssigneeUser: null})}
      >
        <PanelRadioButton
          value='single'
          label='time_off.policy.edit.approvals.Single approval'
          description='time_off.policy.edit.approvals.SINGLE_EXPLANATION_APPROVERS'
        >
          <FirstStageApproverSelect uiState={uiState}/>
        </PanelRadioButton>
        <PanelRadioButton
          value='two_stage'
          label='time_off.policy.edit.approvals.Two-step approval'
          description='time_off.policy.edit.approvals.TWO_STAGE_EXPLANATION'
        >
          <FirstStageApproverSelect uiState={uiState}/>
          <div className='mt2'>
            <ObjectSelect2
              by='userId'
              label='time_off.policy.edit.approvals.Second stage approver(s)'
              value={typePolicy.secondStageApprovers}
              onAdd={approver => uiState.addSecondStageApprover(approver)}
              onRemove={approver => uiState.removeSecondStageApprover(approver)}
              errorMessage={errors.secondStageApprovers}
              items={availableAssignees}
              multiple
              searchable
            />
          </div>
        </PanelRadioButton>
        <PanelRadioButton
          value='auto'
          label='time_off.policy.edit.approvals.Auto approval'
          description='time_off.policy.edit.approvals.AUTO_EXPLANATION'
        />
      </RadioButtonGroup>
    </Panel>
  );
});

export default ApprovalForm;
